import { CSSObject }            from 'styled-components';
import { IScrollablePaneProps } from 'office-ui-fabric-react';


export enum ScrollBarDirection {
  HORIZONTAL,
  VERTICAL,
  BOTH,
}

export enum ScrollBarSize {
  Small,
  Medium,
  Large,
}

export interface CustomScrollBarStyles {
  root: CSSObject;
  track: CSSObject;
  thumb: CSSObject;
  button: CSSObject;
}

export interface ICustomScrollBarProps {
  scrollbarVisibility?: IScrollablePaneProps['scrollbarVisibility'];
  scrollBarSize?: ScrollBarSize;
  isFading?: boolean;
  styles?: Partial<CustomScrollBarStyles>;
}

export interface ICustomScrollBarWrapperProps {
  size: number;
  isFading: boolean;
  withButtons?: boolean;
  styles?: Partial<CustomScrollBarStyles>;
}